// extracted by mini-css-extract-plugin
export default {"emojiModalDiv":"Emoji_emojiModalDiv__1jhM-","showEmojiModalBtn":"Emoji_showEmojiModalBtn__fUvuA","emojiModal":"Emoji_emojiModal__4BLgb"};